export interface SuburbAutocompleteItem {
	PCz_State: string; // ie. VIC, SA
	PCz_Post_Code: string; // ie. 3018
	PCz_Place_Name: string; // ie. ALTONA
}

export enum SuburbAutocompleteItemFields {
	PCz_State = 'PCz_State',
	PCz_Post_Code = 'PCz_Post_Code',
	PCz_Place_Name = 'PCz_Place_Name',
}
